<script>

export default {
  name: 'LayoutCard'
}
</script>

<template lang="pug" src="./LayoutCard.pug"></template>
<style lang="scss" src="./LayoutCard.scss" scoped></style>
